"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyCustomer = void 0;
const tslib_1 = require("tslib");
const AuthenticationFactorStatus_1 = require("../authentication/AuthenticationFactorStatus");
const AuthenticationStatus_1 = require("../authentication/AuthenticationStatus");
const MessageType_1 = require("../message/MessageType");
const Error_1 = require("../shared/Error");
const IResult_1 = require("../shared/IResult");
const IdentifyCustomerResult_1 = require("./IdentifyCustomerResult");
class IdentifyCustomer {
    constructor(request, endpointEngagedHandler, identifyCustomerProvider) {
        this.request = request;
        this.endpointEngagedHandler = endpointEngagedHandler;
        this.identifyCustomerProvider = identifyCustomerProvider;
        if (this.request.payload.channelInstruction.uiPages && this.request.payload.channelInstruction.uiPages.length > 0) {
            this.uiContent = this.request.payload.channelInstruction.uiPages[0];
        }
        else {
            this.uiContent = this.request.payload.channelInstruction.uiContentJSON;
        }
    }
    proceed() {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const sdkToken = (_a = this.request.payload.interaction.customDataSets) === null || _a === void 0 ? void 0 : _a.find(customDataSet => {
                return customDataSet.name === "sdkToken";
            });
            if (!sdkToken || !((_b = this.request.payload.authentication) === null || _b === void 0 ? void 0 : _b.factors))
                return Promise.reject(Error_1.CustomerAuthnError.INTERNAL_ERROR);
            const result = yield this.identifyCustomerProvider.identifyCustomer(sdkToken.value, this.request.payload.authentication.factors);
            return this.handleIdentifyCustomerResult(result);
        });
    }
    handleIdentifyCustomerResult(result) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (result === IdentifyCustomerResult_1.IdentifyCustomerResult.COMPLETED) {
                const authentication = this.updateAuthenticationFactors(AuthenticationStatus_1.AuthenticationStatus.PASSED, AuthenticationFactorStatus_1.AuthenticationFactorStatus.PASSED);
                return this.sendEndpointEngaged(IResult_1.Action.APPROVED, authentication);
            }
            if (result === IdentifyCustomerResult_1.IdentifyCustomerResult.USER_EXITED) {
                const authentication = this.updateAuthenticationFactors(AuthenticationStatus_1.AuthenticationStatus.DENIED, AuthenticationFactorStatus_1.AuthenticationFactorStatus.DISMISSED);
                return this.sendEndpointEngaged(IResult_1.Action.DECLINED, authentication);
            }
            if (result === IdentifyCustomerResult_1.IdentifyCustomerResult.ERROR) {
                const authentication = this.updateAuthenticationFactors(AuthenticationStatus_1.AuthenticationStatus.SYSTEM_ERROR, AuthenticationFactorStatus_1.AuthenticationFactorStatus.REJECTED);
                return this.sendEndpointEngaged(IResult_1.Action.DECLINED, authentication);
            }
        });
    }
    updateAuthenticationFactors(authenticationStatus, factorStatus) {
        var _a, _b;
        const factors = [];
        (_b = (_a = this.request.payload.authentication) === null || _a === void 0 ? void 0 : _a.factors) === null || _b === void 0 ? void 0 : _b.forEach(factor => {
            const updatedFactor = {
                type: factor.type,
                status: factorStatus,
            };
            factors.push(updatedFactor);
        });
        return { status: authenticationStatus, factors };
    }
    sendEndpointEngaged(action, authentication) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const endpointEngagedRequest = {
                messageName: MessageType_1.MessageType.EndpointEngagedRequest,
                payload: {
                    channelInstruction: {
                        type: this.request.payload.channelInstruction.type,
                    },
                    messageID: this.request.payload.messageID,
                    interaction: {
                        entersektInteractionID: this.request.payload.interaction.entersektInteractionID,
                        type: this.request.payload.interaction.type,
                    },
                    result: {
                        action,
                    },
                    authentication,
                },
            };
            return this.endpointEngagedHandler.endpointEngaged(endpointEngagedRequest);
        });
    }
}
exports.IdentifyCustomer = IdentifyCustomer;
//# sourceMappingURL=IdentifyCustomer.js.map